import React from 'react';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const baseStyles = css({
	color: 'currentColor',
	fill: token('color.background.accent.gray.subtler'),
	overflow: 'hidden',
	pointerEvents: 'none',
	/**
	 * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
	 * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
	 * rule) and then override it with currentColor for the color changes to be picked up.
	 */
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles
	stop: {
		stopColor: 'currentColor',
	},
	width: '32px',
	height: '32px',
});

type IconProps = {
	label: string;
};

export const ChildMacroIcon = (props: IconProps) => (
	<svg
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		data-testid="child-macro-icon"
		css={baseStyles}
		aria-label={props.label || undefined}
		role={props.label ? 'img' : 'presentation'}
	>
		<rect
			x="6"
			y="7"
			width="23"
			height="18"
			rx="2"
			fill={token('color.background.accent.blue.subtlest.hovered')}
		/>
		<rect x="9" y="10" width="2" height="2" rx="1" fill={token('color.link')} />
		<rect x="13" y="10" width="13" height="2" rx="1" fill={token('color.link')} />
		<rect x="9" y="15" width="2" height="2" rx="1" fill={token('color.link')} />
		<rect x="13" y="15" width="13" height="2" rx="1" fill={token('color.link')} />
		<rect x="9" y="20" width="2" height="2" rx="1" fill={token('color.link')} />
		<rect x="13" y="20" width="13" height="2" rx="1" fill={token('color.link')} />
		<rect
			x="6"
			y="2"
			width="23"
			height="2"
			rx="1"
			fill={token('color.background.accent.gray.subtlest.pressed')}
		/>
		<rect
			x="6"
			y="28"
			width="23"
			height="2"
			rx="1"
			fill={token('color.background.accent.gray.subtlest.pressed')}
		/>
		<path
			d="M3 3.5L2 2.5"
			stroke={token('color.background.accent.gray.subtlest.pressed')}
			strokeLinecap="round"
		/>
		<path
			d="M3 3.5L4 2.5"
			stroke={token('color.background.accent.gray.subtlest.pressed')}
			strokeLinecap="round"
		/>
		<path
			d="M3.5 29L2.5 30"
			stroke={token('color.background.accent.gray.subtlest.pressed')}
			strokeLinecap="round"
		/>
		<path
			d="M3.5 29L2.5 28"
			stroke={token('color.background.accent.gray.subtlest.pressed')}
			strokeLinecap="round"
		/>
	</svg>
);
